module.exports = new __parcel__URL__("calendar-preview-dark.1428b9c3.svg").toString();